import { useRoutes } from "react-router-dom";
import MainRoutes from "./main-routes";
import SMSResellerPlatform from "../pages/add-reseller";
import Login from "../pages/auth/login";
import ForgotPassword from "../pages/auth/forgot-password";
import Landing from "./landing";
import CreateAccount from "../pages/auth/create-account";
import VerifyAccount from "../pages/auth/verify";
import CreateProfile from "../pages/auth/create-profile";
import ResetPassword from "../pages/auth/reset-password";
import VerifyResetPassword from "../pages/auth/verify-reset-password";
import { GoogleOAuthProvider } from '@react-oauth/google';
// ================|| ROUTING RENDER ||================ //

export default function ThemeRoutes() {
  return useRoutes([
    Landing,
    ...MainRoutes,
    { path: "/login", element: 
      <GoogleOAuthProvider clientId="354372594070-mlstjmuk2qie7qqiqfdaoullkkacss1l.apps.googleusercontent.com">
      <Login />
      </GoogleOAuthProvider>
     },
    { path: "/create-account", element: 
      <GoogleOAuthProvider clientId="354372594070-mlstjmuk2qie7qqiqfdaoullkkacss1l.apps.googleusercontent.com">
    <CreateAccount />
   </GoogleOAuthProvider> },
    { path: "/verify", element: <VerifyAccount /> },
    { path: "/reset-verification", element: <VerifyResetPassword /> },
    { path: "/postsignup", element: <CreateProfile /> },
    { path: "/forgot-password", element: <ForgotPassword /> },
    { path: "/reset-password", element: <ResetPassword /> },
    { path: "/add-reseller", element: <SMSResellerPlatform /> },
  ]);
}
